import React from 'react';
import { Card, renderRow, SexRadios } from 'components';
import { formatPhoneNumber, formatSnils } from '_helpers';
import cn from 'classnames';
import moment from 'moment';
import { Sex } from 'components/enums';

const PersonalDataTab = (
  {
      personalData,
      cardTitle,
      cardCategory,
      withoutPadding,
      withoutPaddingRows,
      cardClassName,
      rowClassName,
      headerChild,
  }: IProps,
) => (
  <Card
    title={cardTitle === null ? undefined : (cardTitle || 'Личные данные')}
    category={cardCategory === null ? undefined : (cardCategory || 'Общая информация')}
    withoutPadding={withoutPadding}
    cardClassName={cardClassName}
    withoutBorder
    headerChild={headerChild}
  >
      {personalData ? (
        <>
            {renderRow('Фамилия', personalData.lastName, rowClassName)}
            {renderRow('Имя', personalData.firstName, rowClassName)}
            {renderRow('Отчество', personalData.middleName, rowClassName)}

            <SexRadios
                sex={personalData.sex}
                validErrors={ { sex: '' } }
                disabled={true}
                onClick={() => true}
                groupClassName={!withoutPaddingRows ? 'mt-5' : ''}
            />

            {renderRow('Дата рождения', personalData.birthDate.format('DD.MM.YYYY'), cn(rowClassName, !withoutPaddingRows && 'mt-5'))}
            {renderRow('Регион', personalData.region || personalData.regionName)}

            {renderRow('Телефон', formatPhoneNumber(personalData.phone) || personalData.phone, cn(rowClassName, !withoutPaddingRows && 'mt-5'))}
            {renderRow('Почта', personalData.email)}

            {renderRow('Снилс', formatSnils(personalData.snils, '-'), cn(rowClassName, !withoutPaddingRows && 'mt-5'))}

            {personalData.placeOfWork && renderRow('МЕСТО РАБОТЫ', personalData.placeOfWork, cn(rowClassName, !withoutPaddingRows && 'mt-5'))}
            {personalData.position && renderRow('ДОЛЖНОСТЬ', personalData.position, rowClassName)}
            {personalData.membership && renderRow('ЧЛЕНСТВА', personalData.membership, rowClassName)}
        </>
      ) : null}
  </Card>
);

export default PersonalDataTab;

interface IProps {
    personalData: IPersonalData | null;
    cardTitle?: string | null;
    cardCategory?: string | null;
    withoutPadding?: boolean;
    withoutPaddingRows?: boolean;
    cardClassName?: string;
    rowClassName?: string;
    headerChild?: React.ReactNode;
}

interface IPersonalData {
    lastName: string;
    firstName: string;
    birthDate: moment.Moment;
    phone: string;
    email: string;
    middleName?: string;
    region?: string;
    regionName?: string;
    snils: string;
    sex: Sex;
    placeOfWork?: string;
    position?: string;
    membership?: string;
}
